export default __webpack_public_path__ + "media/images/cross-c5a38586e09056fe51780342b2c02ef1.svg";